import { useAuthFromUrlToken } from '../../../hooks/useAuthFromUrlToken';

export default function AuthBootstrap({ children }) {
  useAuthFromUrlToken();
  return children;
}
